<template>
  <div>
    <div>
      <p>
        If these assets do not have thumbnails, use this feature to
        regenerate the thumbnails for the selected assets
      </p>
      <div class="d-flex justify-content-between">
        <div>
          <b-button size="sm"
                    :variant="editingSelectionSelectAllButtonVariant('all')"
                    @click="editingSelectionSelectAll(true)">
            Select All
          </b-button>

          <b-button size="sm"
                    :variant="editingSelectionSelectAllButtonVariant('none')"
                    @click="editingSelectionSelectAll(false)">
            Unselect All
          </b-button>
        </div>
        <b-button size="sm" variant="primary" @click="handleRecreateVersions" :disabled="editingSelectionIds.length === 0">Recreate Versions</b-button>
      </div>
      <hr>
    </div>
    <div class="d-flex flex-wrap align-items-center">
      <div class="cursor-pointer border rounded mr-2 mb-1 p-1" v-for="asset in editingAssets">
        <b-checkbox v-model="editingSelection[asset[idKey]]">
          <div class="img-bg img-bg-1 img-square" :style="`background-image: url('${asset.thumb_url}')`"></div>
        </b-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralMixins from "../../../../mixins/GeneralMixins.js";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import {isEqual} from "lodash";

export default {
  props: ['selectedAssets', 'idKey'],
  mixins: [GeneralMixins],
  components: {PulseLoader},
  data() {
    return {
      editingSelection: {},
    }
  },
  computed: {
    editingAssets() {
      return this.selectedAssets;
    },

    selectedAssetIds: function () {
      return this.selectedAssets.map(el => el[this.idKey])
    },

    editingSelectionAllSelected() {
      if (!this.editingSelection) {
        return false
      }

      return isEqual(this.editingSelectionIds, Object.keys(this.editingSelection))
    },

    editingSelectionNoneSelected() {
      if (!this.editingSelection) {
        return false
      }

      return isEqual(this.editingSelectionIds, [])
    },

    editingSelectionIds() {
      if (!this.editingSelection) {
        return []
      }

      return Object.keys(this.editingSelection).filter(id => this.editingSelection[id])
    },
  },
  mounted() {
    this.selectAll()
  },
  methods: {
    handleRecreateVersions() {
      const attributes = {
        asset_ids: this.editingSelectionIds,
      }

      this.$http.post("/curators/bulk/recreate_versions", attributes).then(result => {
        this.showToast(`Started thumbnail regeneration for ${this.editingSelectionIds.length} assets`, "Success")
        this.editingSelection = {}
      }, rejectionResult => {
        this.showErrorToast(null, rejectionResult.body.errors)
      });
    },

    editingSelectionSelectAllButtonVariant(type) {
      if (type === 'all') {
        if (this.editingSelectionAllSelected) {
          return "primary"
        } else {
          return "outline-secondary"
        }
      } else {
        if (this.editingSelectionNoneSelected) {
          return "primary"
        } else {
          return "outline-secondary"
        }
      }
    },
    editingSelectionSelectAll(value) {
      for (const key in this.editingSelection) {
        this.editingSelection[key] = value
      }
    },
    selectAll() {
      this.editingSelection = Object.assign({}, ...this.selectedAssetIds.map(id => {
        return {
          [id]: true
        }
      }))
    }
  },

}
</script>